import * as axios from 'node_modules/axios/dist/axios.js';
import videojs from 'video.js';
import YouTube from 'node_modules/videojs-youtube/dist/Youtube.min.js';

export default class accessibleYoutube {
    constructor() {
        $(window).ready(() => {
            this.initVideoJS();
        });
    }

    initVideoJS() {
        //let $videoInfo = $('.video-information-js');
        let $videoBlocks = $('.accessible-yt-js');

        $videoBlocks.each((index, $videoBlock) => {
            $videoBlock = $($videoBlock);
            let $videoInfo = $videoBlock.find('.video-information-js');
            videojs(
                $videoInfo.attr('data-block-id'),
                {
                    techOrder: [
                        'youtube',
                    ],
                    children: [
                        'mediaLoader',
                        'posterImage',
                        'textTrackDisplay',
                        'loadingSpinner',
                        'bigPlayButton',
                        'controlBar',
                        'errorDisplay',
                        'textTrackSettings',
                        'resizeManager',
                    ],
                    language: 'en-us',
                    notSupportedMessage: 'No compatible source was found for this media.',
                    sources: [
                        {
                            type: 'video/youtube',
                            src: $videoInfo.attr('data-url'),
                        },
                    ],
                    youtube: {
                        modestbranding: 1,
                        customVars: {
                            rel: 0,
                        },
                    },
                    aspectRatio: '16:9',
                    fluid: true,
                    autoplay: Number(
                        $('#accessibleYT-'+$videoInfo.attr('data-block-id')).attr('data-autoplay')
                    ),
                    controls: true,
                    initChildren: false,
                    createEl: false,
                    reportTouchActivity: true,
                    controlBar: {
                        pictureInPictureToggle: false,
                    },
                }
            ).ready(function () {
                let trackEl = this.addRemoteTextTrack({
                    kind: 'subtitles',
                    src: $videoInfo.attr('data-captions-url'),
                    default: true,
                    srclang: 'en',
                    label: 'English',
                }, false);
            });
        });
    }
}
